import { TabPill } from 'types/tabs';

export enum LeadSettingIds {
  CALENDAR_CONFERENCING = 'calendar-conferencing',
  LEAD_CONFIGURATION = 'lead-configuration'
}

export const leadSettingsTabs: TabPill[] = [
  {
    id: LeadSettingIds.CALENDAR_CONFERENCING,
    label: 'Calendar & Conferencing'
  },
  { id: LeadSettingIds.LEAD_CONFIGURATION, label: 'Configuration' }
];
